import { createSlice } from "@reduxjs/toolkit";
import { convertRatingArrayToObj } from "utils/hooks/handleObjAndArray";
import { RatingQualsType, RatingScoresType, RatingTopicsType } from "utils/Types";

type RatingsSliceType = {
  topics: RatingTopicsType[];
  scores: RatingScoresType[] | any;
  initialValue: RatingQualsType;
  ratedStudent: any;
};

const RatingsInit: RatingsSliceType = {
  topics: [],
  scores: [],
  initialValue: {} as RatingsSliceType["initialValue"],
  ratedStudent: {}
};

export const RatingsSlice = createSlice({
  name: "ratings",
  initialState: RatingsInit,
  reducers: {
    setScoreAndValue: (state, action) => {
      const newScore = action.payload;
      const newInitialValue = convertRatingArrayToObj(newScore);
      state.scores = newScore;
      state.initialValue = newInitialValue;
    },
    setTopics: (state, action) => {
      state.topics = action.payload;
    },
    resetRatings: () => {
      return RatingsInit;
    },
    addRatedStudent: (state, action) => {
      state.ratedStudent = action.payload;
    },
    removeRatedStudent: state => {
      state.ratedStudent = {};
    }
  }
});

export const { setScoreAndValue, setTopics, resetRatings, addRatedStudent, removeRatedStudent } =
  RatingsSlice.actions;

export default RatingsSlice.reducer;
